const IS_LOADING = "cpls/IS_LOADING";
const IS_PARTIAL_LOADING = "cpls/IS_PARTIAL_LOADING";
const IS_ERROR = "cpls/IS_ERROR";
const CPLS = "cpls/CPLS";
const MAP_CPL = "cpls/MAP_CPL";
const IGNORE_CPL = "cpls/IGNORE_CPL";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, CPLS, MAP_CPL, IGNORE_CPL };
